import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

import { PreCheckWarningList } from './pre-check-warnings'

type Props = {
  open: boolean
  onConfirm: () => void
  onCancel: () => void
  // When provided, warning details are rendered inline (combine wizard case
  // where we know the single doc's warnings). Omitted = generic copy only
  // (upload page case where per-doc detail lives in each row's info modal).
  codes?: string[]
}

export const PreCheckConfirmDialog = ({ open, onConfirm, onCancel, codes }: Props) => {
  const { t } = useTranslation()
  const hasCodes = (codes?.length ?? 0) > 0

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent className="max-w-md" hideCloseButton>
        <DialogHeader>
          <DialogTitle>{t('preCheckConfirm.title')}</DialogTitle>
          {!hasCodes && (
            <DialogDescription>{t('preCheckConfirm.body')}</DialogDescription>
          )}
        </DialogHeader>

        {hasCodes && <PreCheckWarningList codes={codes!} />}

        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            {t('preCheckConfirm.cancel')}
          </Button>
          <Button onClick={onConfirm}>{t('preCheckConfirm.confirm')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
